import { render, staticRenderFns } from "./tree-people.vue?vue&type=template&id=316219f6"
import script from "./tree-people.vue?vue&type=script&lang=js"
export * from "./tree-people.vue?vue&type=script&lang=js"
import style0 from "./tree-people.vue?vue&type=style&index=0&id=316219f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports